module.exports = __webpack_public_path__ + "0567d09d76d9f053e2aad0094a11b8d5.svg";